import styled from 'styled-components';

import { Asterisk, type AsteriskProps } from '@xing-com/crate-upsell-asterisk';
import { mediaWide } from '@xing-com/layout-tokens';
import { spaceL, spaceXL } from '@xing-com/tokens';
import { Column } from '@xing-com/xing-grid';

import type { OfferBoxProps } from './offer-box';
import { OfferBox } from './offer-box';

type OfferBoxColumnProps = OfferBoxProps & AsteriskProps;

export function OfferBoxColumn({
  product,
  premiumContacts,
  contracts,
  endsAt,
  disabled,
  showFacepile,
  showOfferPicker,
  legalNotice,
  textValues,
}: OfferBoxColumnProps): JSX.Element {
  return (
    <Column size={12} sizeWide={5}>
      <OfferBox
        product={product}
        showFacepile={showFacepile}
        premiumContacts={premiumContacts}
        contracts={contracts}
        endsAt={endsAt}
        textValues={textValues}
        disabled={disabled}
        showOfferPicker={showOfferPicker}
      />
      <StyledAsterisk legalNotice={legalNotice} />
    </Column>
  );
}

const StyledAsterisk = styled(Asterisk)`
  margin-top: ${spaceL};

  @media ${mediaWide} {
    margin-top: ${spaceXL};
  }
`;
